import { createSafeJotaiSessionStorage } from '@/lib/jotai-storage';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { atomWithStorage } from 'jotai/utils';

/**
 * Reopens the signup personalization flow on `/scribe/new-user` for an account
 * that has already completed it. Ignored in production.
 *
 * Session-scoped rather than persistent: the override suppresses a redirect, so
 * a forgotten `true` would keep bouncing the tab back into onboarding. Closing
 * the tab clears it.
 */
export const onboardingFlowDevForceReplayAtom = atomWithStorage<boolean>(
  'heidi.devTools.onboarding.forceReplay',
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

onboardingFlowDevForceReplayAtom.debugLabel = 'onboardingFlowDevForceReplayAtom';

export const isOnboardingFlowDevOverridesEnabled = (): boolean =>
  getEnvironment() !== ENV_NAME.PROD;
